import type { InvoiceIssuerField } from '@/shared/api';

/**
 * Die Pflichtangaben zum Aussteller mit den Wörtern des Formulars. Welche fehlen, entscheidet der
 * Server (`missingIssuerFields`) — die Oberfläche benennt sie nur.
 */
const ISSUER_FIELD_LABEL: Record<InvoiceIssuerField, string> = {
  CompanyName: 'Firmenname',
  BillingStreet: 'Straße und Hausnummer',
  BillingPostalCode: 'PLZ',
  BillingCity: 'Ort',
  BillingCountry: 'Land',
  TaxNumberOrVatId: 'Steuernummer oder USt-IdNr.',
};

export function missingIssuerText(fields: readonly InvoiceIssuerField[]): string {
  const labels = fields.map((field) => ISSUER_FIELD_LABEL[field] ?? field);
  const text = `${labels.length === 1 ? 'Es fehlt' : 'Es fehlen'}: ${labels.join(', ')}`;
  // „USt-IdNr." bringt seinen Punkt schon mit.
  return text.endsWith('.') ? text : `${text}.`;
}
